// ✅ EditItemModal.js
import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Grid,
  Snackbar,
  Alert,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { useOrder } from "../../../../../../../../context/OrderCreator/TablesContext/OrderContext"; // 👈 استدعاء الـ context

const EditItemModal = ({ open, onClose, item }) => {
  const { updateItem } = useOrder(); // 👈 نجيب الدالة من الكونتكست
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("sm")); // small phones
  const isTablet = useMediaQuery("(min-width:600px) and (max-width:1024px)"); // tablets / iPad
  const dialogWidth = isXs ? "100vw" : isTablet ? "80vw" : "520px";
  const controlSize = isTablet ? "medium" : isXs ? "small" : "small";

  useEffect(() => {
    if (item) setForm({ ...item });
  }, [item]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };
  const handleSubmit = async () => {
    console.log("🚀 handleSubmit اشتغل، item:", item, "form:", form); // ✅

    try {
      setLoading(true);

      console.log("📤 ارسال للتعديل:", {
        id: item?.id,
        quantity: form.quantity,
        price: form.price,
        note: form.note,
      });

      await updateItem({
        id: Number(item?.id),
        quantity: form.quantity,
        price: form.price,
        note: form.note,
      });

      setSuccess(true);
      onClose && onClose(true);
    } catch (err) {
      console.error("❌ خطأ في handleSubmit:", err);
      setError(err.message || "❌ فشل في تعديل بيانات الصنف");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={() => onClose(false)}
        fullScreen={isXs}
        maxWidth={false}
        PaperProps={{
          sx: {
            width: dialogWidth,
            maxWidth: "98vw",
            borderRadius: 2,
            bgcolor: "background.paper",
          },
        }}
      >
        <DialogTitle sx={{ fontSize: { xs: 18, sm: 20 }, py: { xs: 1, sm: 1.5 }, px: { xs: 2, sm: 3 } }}>
          تعديل بيانات الصنف: {item?.product_name}
        </DialogTitle>
        <DialogContent dividers sx={{ px: { xs: 2, sm: 3 }, py: { xs: 1, sm: 2 } }}>
          <Grid container spacing={2} mt={1}>
            <Grid item xs={12} sm={6}>
              <TextField
                label="الكمية"
                name="quantity"
                type="number"
                fullWidth
                size={controlSize}
                inputProps={{ min: 1 }}
                value={form.quantity || ""}
                onChange={handleChange}
                aria-label="الكمية"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="السعر"
                name="price"
                type="number"
                fullWidth
                size={controlSize}
                inputProps={{ min: 0, step: "0.01" }}
                value={form.price || ""}
                onChange={handleChange}
                aria-label="السعر"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="ملاحظات"
                name="note"
                fullWidth
                size={controlSize}
                multiline
                minRows={2}
                value={form.note || ""}
                onChange={handleChange}
                aria-label="ملاحظات"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ px: { xs: 2, sm: 3 }, py: { xs: 1, sm: 1.5 } }}>
          <Button onClick={() => onClose(false)} size={controlSize}>
            إلغاء
          </Button>
          <Button variant="contained" onClick={handleSubmit} disabled={loading} size={controlSize}>
            حفظ التعديلات
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={!!error}
        autoHideDuration={3000}
        onClose={() => setError("")}
      >
        <Alert severity="error">{error}</Alert>
      </Snackbar>

      <Snackbar
        open={success}
        autoHideDuration={3000}
        onClose={() => setSuccess(false)}
      >
        <Alert severity="success">تم تعديل بيانات الصنف بنجاح</Alert>
      </Snackbar>
    </>
  );
};

export default EditItemModal;
